import { BoxOfferType } from "@modules/boxOffer/entities/boxOfferTypes"
import { useBoxOffer } from "@modules/boxOffer/hooks/useBoxOffer"
import {
  CouponInputFormik,
  couponYupValidation,
  DurationType,
} from "@modules/boxSubscription/formik/boxSubscriptionFormik"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { DiscountOfferForm } from "@modules/formik/components/discountOfferForm"
import { HUButton } from "@modules/ui/components/huButton"
import { HUText } from "@modules/ui/components/huText"
import { LoggerType } from "@modules/utils/loggerUtils"
import { useFormik } from "formik"
import { ArrowLeft, Percent } from "lucide-react"
import { Dispatch, SetStateAction } from "react"
import { useTheme } from "styled-components"

export type MemberSendOfferModalDiscountProps = {
  boxOfferId: string
  discountInput: CouponInputFormik
  setDiscountInput: Dispatch<SetStateAction<CouponInputFormik>>
  setIsDiscountVisible: Dispatch<SetStateAction<boolean>>
} & React.HTMLAttributes<HTMLDivElement>

export const MemberSendOfferModalDiscount: React.FC<MemberSendOfferModalDiscountProps> = ({
  boxOfferId,
  discountInput,
  setDiscountInput,
  setIsDiscountVisible,
  ...props
}) => {
  const theme = useTheme()
  const defaultClassName = "flex flex-column mt-4 w-full gap-4 flex-grow-1"
  const { data: boxOffer } = useBoxOffer(boxOfferId)

  const formik = useFormik<CouponInputFormik>({
    initialValues: { ...discountInput },
    validationSchema: couponYupValidation({ priceOffer: boxOffer?.price?.value || 0 }),
    onSubmit: async () => {
      try {
        setDiscountInput(formik.values)
        setIsDiscountVisible(false)
      } catch (e: any) {
        console.error(LoggerType.UI + "discount in send box offer", e)
      }
    },
  })

  return (
    <div className={props.className ?? defaultClassName} {...props}>
      {/* TITLE */}
      <div className="flex gap-2 align-items-center justify-content-center">
        <Percent color={theme.mainWhite} strokeWidth={1} size={13} />
        <HUText fontStyle="TS" color={theme.mainWhite} className="text-center">
          {word("member.send.offer.modal.discount.title")}
        </HUText>
      </div>
      {boxOffer && boxOffer.price && (
        <DiscountOfferForm
          className="flex flex-column w-full"
          formik={formik}
          isPending={false}
          price={boxOffer.price}
          isDisableMonthsInput={boxOffer.type === BoxOfferType.Subscription ? false : true}
        />
      )}

      {/* BUTTON */}
      <div className="flex flex-row flex-grow-1 gap-2 mt-2 align-items-end justify-content-center">
        <HUButton
          type="Left_Icon"
          size="M"
          colorType="Quaternary"
          text={discountInput.value !== 0 ? word("global.reset") : word("global.cancel")}
          onClick={() => {
            setIsDiscountVisible(false)
            setDiscountInput({
              type: CouponType.PERCENT,
              value: 0,
              durationType: DurationType.UNLIMITED,
              months: null,
            })
          }}
          icon={{
            iconView: <ArrowLeft strokeWidth={2} color={theme.mainWhite} size={15} />,
          }}
          className="w-full"
        />
        <HUButton
          type="Right_Icon"
          size="M"
          colorType="Primary"
          text={word("global.check")}
          onClick={() => formik.handleSubmit()}
          className="w-full"
        />
      </div>
    </div>
  )
}
